import {StyleSheet} from 'react-native';
import CCColors from '@/Utils/CCColors';
import {vs, hs} from '@/Utils/Dimensions';

const AQUA = CCColors.Primary.Aqua; // #3DAB9E

export const couponStyles = StyleSheet.create({
  // Disabled info box
  disabledBox: {
    backgroundColor: CCColors.Primary.Light,
    borderRadius: 10,
    padding: 12,
  },

  // Collapsed teaser button
  collapsedBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: hs(8),
    borderWidth: 1.5,
    borderStyle: 'dashed',
    borderColor: 'rgba(77,63,55,0.22)',
    borderRadius: 12,
    paddingVertical: vs(10),
    paddingHorizontal: hs(14),
    backgroundColor: 'transparent',
  },
  collapsedText: {
    flex: 1,
    fontSize: 13,
    color: CCColors.TextColor.Primary,
  },
  chevron: {
    fontSize: 16,
    color: CCColors.TextColor.Grey,
    lineHeight: 18,
  },

  // Open input state
  openWrap: {
    gap: vs(6),
    marginTop: vs(8),
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: hs(8),
  },
  inputWrap: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: hs(5),
    backgroundColor: '#fff',
    borderWidth: 1.5,
    borderColor: 'rgba(77,63,55,0.18)',
    borderRadius: 12,
    paddingHorizontal: hs(5),
    height: 40,
  },
  inputWrapFocused: {
    borderColor: '#FACF47',
  },
  couponInput: {
    flex: 1,
    height: 38,
    paddingLeft: 10,
  },
  applyBtn: {
    backgroundColor: CCColors.TextColor.Dark,
    borderRadius: 10,
    paddingHorizontal: hs(18),
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: hs(40),
  },
  applyBtnDisabled: {
    backgroundColor: '#CCCCCC',
  },
  hintText: {
    fontSize: 11,
    color: CCColors.TextColor.Grey,
    lineHeight: 15,
    paddingHorizontal: hs(4),
  },
  errorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: hs(4),
    paddingHorizontal: hs(4),
  },
  errorText: {
    fontSize: 11,
    color: CCColors.Error,
    lineHeight: 15,
  },
  errorCodeChip: {
    backgroundColor: `${CCColors.Error}18`,
    paddingHorizontal: hs(6),
    paddingVertical: vs(1),
    borderRadius: 4,
  },
  errorCodeText: {
    fontSize: 11,
    color: CCColors.Error,
    fontFamily: 'DMSans-SemiBold',
    letterSpacing: 0.4,
  },

  // Compact variant — for tight contexts like the desktop ticket stub column
  compactCollapsedBtn: {
    paddingVertical: vs(9),
    paddingHorizontal: hs(12),
    backgroundColor: 'rgba(255,255,255,0.55)',
    borderColor: 'rgba(77,63,55,0.20)',
  },
  compactCollapsedText: {
    fontSize: 12,
  },
  compactInputWrap: {
    backgroundColor: 'rgba(255,255,255,0.85)',
  },
  compactAppliedWrap: {
    paddingVertical: vs(8),
    paddingHorizontal: hs(10),
  },
  compactAppliedCode: {
    fontSize: 12,
  },
  compactAppliedSavings: {
    fontSize: 10,
  },
  compactApplyBtn: {
    paddingHorizontal: 14,
  },

  // Applied state
  appliedWrap: {
    backgroundColor: `${AQUA}14`,
    borderWidth: 1.5,
    borderColor: `${AQUA}59`,
    borderRadius: 12,
    paddingVertical: vs(10),
    paddingHorizontal: hs(14),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  appliedLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: hs(10),
    flex: 1,
  },
  appliedBadge: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: `${AQUA}2E`,
    alignItems: 'center',
    justifyContent: 'center',
  },
  appliedTextWrap: {
    gap: vs(1),
  },
  appliedCode: {
    fontSize: 13,
    color: CCColors.TextColor.Dark,
    fontFamily: 'DMSans-SemiBold',
  },
  appliedSavings: {
    fontSize: 11,
    color: AQUA,
    fontFamily: 'DMSans-Medium',
  },
  removeBtn: {
    padding: 4,
  },

  // Swap link
  swapLink: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: hs(4),
    paddingVertical: vs(4),
    paddingHorizontal: hs(2),
    alignSelf: 'flex-start',
  },
  swapLinkText: {
    fontSize: 12,
    color: CCColors.TextColor.Grey,
  },
  swapLinkPlus: {
    fontSize: 14,
    color: CCColors.TextColor.Grey,
    lineHeight: 16,
  },
  cancelLink: {
    paddingVertical: vs(4),
    paddingHorizontal: hs(2),
    alignSelf: 'flex-start',
  },
  cancelText: {
    fontSize: 11,
    color: CCColors.TextColor.Grey,
    textDecorationLine: 'underline',
  },

  // Price summary box
  summaryBox: {
    backgroundColor: `${CCColors.TextColor.Grey}20`,
    borderRadius: 10,
    padding: 12,
    gap: vs(6),
    marginTop: vs(8),
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  summaryTotal: {
    borderTopWidth: 1,
    borderTopColor: 'rgba(77,63,55,0.12)',
    paddingTop: vs(6),
    marginTop: vs(2),
  },
});

export const confirmStyles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(38,35,34,0.55)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 20,
    width: '100%',
    maxWidth: 380,
    padding: 22,
    gap: vs(14),
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 10},
    shadowOpacity: 0.28,
    shadowRadius: 20,
    elevation: 20,
  },
  iconContainer: {
    width: 44,
    height: 44,
    borderRadius: 14,
    backgroundColor: 'rgba(250,207,71,0.18)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 18,
    color: CCColors.TextColor.Dark,
    lineHeight: 24,
  },
  subtitle: {
    fontSize: 13,
    color: CCColors.TextColor.Primary,
    lineHeight: 20,
  },
  codeChip: {
    backgroundColor: CCColors.Primary.Light,
    paddingHorizontal: 6,
    paddingVertical: 1,
    borderRadius: 4,
  },
  compareBox: {
    backgroundColor: CCColors.Primary.Light,
    borderRadius: 12,
    padding: 8,
    gap: vs(8),
  },
  compareRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    borderRadius: 10,
    paddingVertical: vs(10),
    paddingHorizontal: hs(12),
    borderWidth: 1,
    borderColor: 'transparent',
  },
  compareRowBest: {
    backgroundColor: 'rgba(61,171,158,0.06)',
    borderColor: 'rgba(61,171,158,0.35)',
  },
  rowLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: hs(10),
    flex: 1,
  },
  rowLeftText: {
    gap: vs(2),
  },
  rowRight: {
    alignItems: 'flex-end',
    gap: vs(2),
  },
  pill: {
    fontSize: 9,
    fontFamily: 'DMSans-Bold',
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    backgroundColor: CCColors.Primary.Light,
    color: CCColors.TextColor.Grey,
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 999,
    overflow: 'hidden',
  },
  pillBest: {
    backgroundColor: AQUA,
    color: '#fff',
  },
  rowCode: {
    fontSize: 13,
    color: CCColors.TextColor.Dark,
    fontFamily: 'DMSans-SemiBold',
  },
  rowSavings: {
    fontSize: 11,
    color: CCColors.TextColor.Grey,
  },
  rowPrice: {
    fontSize: 24,
    color: CCColors.TextColor.Dark,
    fontFamily: 'Thunder',
    lineHeight: 28,
  },
  rowPriceBest: {
    color: AQUA,
  },
  rowPriceNew: {
    color: CCColors.Red,
  },
  rowPriceLabel: {
    fontSize: 10,
    color: CCColors.TextColor.Grey,
  },
  delta: {
    fontSize: 11,
    color: CCColors.Red,
    fontFamily: 'DMSans-SemiBold',
  },
  actions: {
    gap: vs(8),
    marginTop: vs(2),
  },
  switchLink: {
    fontSize: 12,
    color: CCColors.TextColor.Grey,
    textDecorationLine: 'underline',
    textAlign: 'center',
    padding: vs(6),
  },
});
